import React, { useState } from "react";
import { connect } from "react-redux";
import PrecertificacionActions from "../../../stores/precertificacion/Actions";
import AuthActions from "../../../stores/auth/Actions";
import { useMountEffect, useUpdateEffect } from "../../../hooks/LifeCycle";
import useEmpresa from "../../../hooks/useEmpresa";
import CustomLayout from "../../../components/CustomLayout/CustomLayout";
import CheckRender from "../../../components/Common/CheckRender";
import TittleLine from "../../../components/Common/TittleLine";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import DetallePrecertificacion from "../components/DetallePrecertificacion";
import BusquedaPrecertificacionForm from "../components/BusquedaPrecertificacionForm";
import {
  PRECERTIFICACION_WARNING,
  ESTADO_PRECERTIFICACION,
  getFooterPosition,
  getFooterWidth,
} from "../utils/PrecertificacionConstants";
import { isObjectEmpty } from "../../../utils/ObjectUtil";
import CustomAlert from "../../../components/Common/CustomAlert";
import { mostrarErrorGenerico } from "../../../utils/AlertUtils";
import { isEmptyValue } from "../../../utils/StringUtil";

const ConfirmarPrecertificacionScreen = (props) => {
  const empresa = useEmpresa();

  const [formData, setFormData] = useState({
    numeroPrecertificacion: "",
  });

  const [showDetail, setShowDetail] = useState(false);
  const [showAutorizacion, setShowAutorizacion] = useState(false);
  const [dataPrecertificacion, setDataPrecertificacion] = useState(null);
  const [dataAutorizacion, setDataAutorizacion] = useState(null);
  const [datosAutorizacionMadre, setDatosAutorizacionMadre] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [loadingAutorizacionData, setLoadingAutorizacionData] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertConfig, setAlertConfig] = useState({});
  const [numeroAutorizacionHumano, setNumeroAutorizacionHumano] =
    useState(null);
  // const [numeroAutorizacionPrimera, setNumeroAutorizacionPrimera] =
  //   useState(null);

  const [esFlujoSam, setEsFlujoSam] = useState(false);

  useMountEffect(() => {
    props.clearSesion();
  });

  const cargarDatosAutorizacionMadre = async (numeroAutorizacionMadre) => {
    if (!numeroAutorizacionMadre) {
      console.error("Número de autorización madre no proporcionado");
      return;
    }

    try {
      const { numeroSesionReutilizable } = props?.authUserData;
      setLoadingAutorizacionData(true);

      props.getAutorizacionMadreData({
        numeroSesion: numeroSesionReutilizable,
        numeroAutorizacion: numeroAutorizacionMadre,
      });
    } catch (error) {
      console.error("Error al cargar datos de autorización madre:", error);
      setLoadingAutorizacionData(false);
    }
  };

  /**
   * Consultar precertificación Success.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.getPrecertificacionData) && processing) {
      setProcessing(false);

      setDataPrecertificacion(props?.getPrecertificacionData?.precertificacion);

      setShowDetail(true);
    }
  }, [props.getPrecertificacionData]);

  /**
   * Consultar precertificación Error.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.getPrecertificacionError) && processing) {
      setProcessing(false);
      mostrarErrorGenerico(
        props?.getPrecertificacionError,
        setProcessing,
        setAlertConfig,
        setShowAlert
      );
    }
  }, [props.getPrecertificacionError]);

  /**
   * Confirmar precertificación Success.
   */
  useUpdateEffect(() => {
    if (!isObjectEmpty(props?.confirmarPrecertificacionData) && processing) {
      setProcessing(false);

      try {
        const { autorizacion } = props?.confirmarPrecertificacionData || {};

        if (autorizacion) {
          const esAutorizacionMadre = !!autorizacion?.detalleAutorizacionMadre;
          setEsFlujoSam(esAutorizacionMadre);

          setDataAutorizacion(autorizacion);
          setShowAutorizacion(true);

          setDataPrecertificacion({
            ...dataPrecertificacion,
            nombreEstado: ESTADO_PRECERTIFICACION.CONVERTIDA,
          });

          if (esAutorizacionMadre) {
            setNumeroAutorizacionHumano(autorizacion.detalleAutorizacionMadre?.reclamoHumano || null);
            // setNumeroAutorizacionPrimera(
            //   autorizacion.detalleAutorizacionMadre?.reclamoPrimera || null
            // );

            if (
              autorizacion.detalleAutorizacionMadre?.numeroAutorizacionMadre
            ) {
              cargarDatosAutorizacionMadre(
                autorizacion.detalleAutorizacionMadre.numeroAutorizacionMadre ||
                  autorizacion.detalleAutorizacionMadre.numeroMadre
              );
            }
          } else {
            setNumeroAutorizacionHumano(autorizacion.numeroAutorizacion);
            // setNumeroAutorizacionPrimera(null);
          }

          setAlertConfig({
            type: "success",
            title: `Precertificación ${dataPrecertificacion?.numeroPrecertificacion} confirmada con éxito!`,
            message: `${
              esAutorizacionMadre
                ? (() => {
                    const reclamoHumano =
                      autorizacion.detalleAutorizacionMadre?.reclamoHumano;
                    const reclamoPrimera =
                      autorizacion.detalleAutorizacionMadre?.reclamoPrimera;

                    let mensaje = "";

                    if (reclamoHumano) {
                      mensaje += `Número de Autorización Humano Seguros: (${reclamoHumano})`;
                    }

                    if (reclamoPrimera) {
                      if (mensaje) mensaje += "\n";
                      mensaje += `Número de Autorización ARS Primera: (${reclamoPrimera})`;
                    }

                    return mensaje || "La autorización fue creada exitosamente";
                  })()
                : `Número de Autorización: ${autorizacion.numeroAutorizacion}`
            }`,
            onConfirm: () => {
              setShowAlert(false);
            },
          });
          setShowAlert(true);
        } else {
          setAlertConfig({
            type: "warning",
            title: "Información incompleta",
            message:
              "No se pudo obtener la información completa de la autorización.",
            onConfirm: () => {
              setShowAlert(false);
            },
          });
          setShowAlert(true);
        }
      } catch (error) {
        console.error("Error al procesar datos de confirmación:", error);
        setAlertConfig({
          type: "error",
          title: "Error al procesar datos",
          message: "Ocurrió un error al procesar los datos de la autorización.",
          onConfirm: () => {
            setShowAlert(false);
          },
        });
        setShowAlert(true);
      }
    }
  }, [props.confirmarPrecertificacionData]);

  useUpdateEffect(() => {
    if (!props?.autorizacionMadreData) {
      return;
    }

    if (loadingAutorizacionData) {
      setLoadingAutorizacionData(false);
    }

    try {
      const { autorizacionMadre, autorizacionMadreCoberturaSalud = [] } =
        props.autorizacionMadreData || {};

      if (!autorizacionMadre) {
        return;
      }

      setDatosAutorizacionMadre({
        autorizacionMadre,
        autorizacionMadreCoberturaSalud,
      });

      if (Array.isArray(autorizacionMadreCoberturaSalud)) {
        const procedimientosTransformados = autorizacionMadreCoberturaSalud.map(
          (cobertura) => ({
            codigo: cobertura.cobertura,
            nombre: cobertura.descripcion,
            frecuencia: cobertura.cantidad,
            montoReclamado: cobertura.montoReclamado,
            montoAutorizacionPrimera: cobertura.montoAutorizacionPrimera,
            montoAutorizacionHumano: cobertura.montoAutorizacionHumano,
            montoARS: cobertura.montoAutorizado,
            montoAfiliado: cobertura.montoAsegurado,
          })
        );

        setDataAutorizacion((prevData) => {
          if (!prevData) return prevData;

          return {
            ...prevData,
            procedimientos: procedimientosTransformados,
            detalleAutorizacionMadre: {
              ...prevData?.detalleAutorizacionMadre,
              numeroAutorizacionMadre: autorizacionMadre.numeroMadre,
              fechaServicio: autorizacionMadre.fechaServicio,
              reclamoHumano: autorizacionMadre.numeroReclamacionHumano,
              reclamoPrimera: autorizacionMadre.numeroReclamacionPrimera,
            },
          };
        });
      }
    } catch (error) {
      console.error("Error al procesar datos de autorización madre:", error);
      setLoadingAutorizacionData(false);
    }
  }, [props.autorizacionMadreData]);

  useUpdateEffect(() => {
    if (
      !isObjectEmpty(props?.getAutorizacionMadreDataError) &&
      loadingAutorizacionData
    ) {
      setLoadingAutorizacionData(false);
      console.error(
        "Error al obtener datos de autorización madre:",
        props?.getAutorizacionMadreDataError
      );
    }
  }, [props.getAutorizacionMadreDataError]);

  const onStateChange =
    (key, format = null) =>
    (value) => {
      setFormData((prevState) => {
        return {
          ...prevState,
          [key]: format ? format(value) : value,
        };
      });
    };

  const busquedaPrecertificacion = () => {
    const { numeroPrecertificacion } = formData;

    if (isEmptyValue(numeroPrecertificacion)) {
      setAlertConfig({
        type: "info",
        title: "¡Hola!",
        message: "Favor ingresar el número de precertificación.",
        onConfirm: () => {
          setShowAlert(false);
        },
      });

      setShowAlert(true);
      return;
    }

    setShowAutorizacion(false);

    setShowDetail(false);

    const { numeroSesionReutilizable } = props?.authUserData;

    setProcessing(true);

    props.getPrecertificacion({
      numeroSesion: numeroSesionReutilizable,
      numeroPrecertificacion: formData.numeroPrecertificacion,
      compania: empresa?.CODIGO,
    });
  };

  const confirmar = () => {
    const { numeroSesionReutilizable } = props?.authUserData;

    setProcessing(true);

    props.confirmarPrecertificacion({
      numeroSesion: numeroSesionReutilizable,
      numeroPrecertificacion: dataPrecertificacion?.numeroPrecertificacion,
      compania: empresa?.CODIGO,
      numeroPlastico: dataPrecertificacion?.afiliado?.numeroPlastico,
    });
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      busquedaPrecertificacion();
    }
  };

  return (
    <CustomLayout
      showMenuNav={true}
      footerPosition={getFooterPosition(showDetail)}
      footerWidth={getFooterWidth(showDetail)}
    >
      <Section>
        <TittleLine title={`Confirmar Precertificación`} weight={"bold"} />
      </Section>

      <Section>
        <BusquedaPrecertificacionForm
          {...formData}
          onStateChange={onStateChange}
          onSearch={busquedaPrecertificacion}
          isLoading={props.getPrecertificacionLoading}
          handleKeyPress={handleKeyPress}
        />
      </Section>

      <CheckRender allowed={showDetail}>
        <Section>
          <DetallePrecertificacion
            dataPrecertificacion={dataPrecertificacion}
            dataAutorizacion={dataAutorizacion}
            showAutorizacion={showAutorizacion}
            numeroAutorizacionHumano={numeroAutorizacionHumano}
            actionButtonLoading={
              props.confirmarPrecertificacionLoading || loadingAutorizacionData
            }
            esFlujoSam={esFlujoSam}
            onSubmitAction={confirmar}
            actionButton={"Autorizar"}
            warningText={PRECERTIFICACION_WARNING.CONFIRMAR}
            datosAutorizacionMadre={datosAutorizacionMadre}
          />
        </Section>
      </CheckRender>

      <CheckRender allowed={showAlert}>
        <CustomAlert {...alertConfig} />
      </CheckRender>
    </CustomLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    authUserData: state.auth.authUserData,
    authUserLoading: state.auth.authUserLoading,
    authUserError: state.auth.authUserError,

    getPrecertificacionData: state.precertificacion.getPrecertificacionData,
    getPrecertificacionLoading:
      state.precertificacion.getPrecertificacionLoading,
    getPrecertificacionError: state.precertificacion.getPrecertificacionError,

    confirmarPrecertificacionData:
      state.precertificacion.confirmarPrecertificacionData,
    confirmarPrecertificacionLoading:
      state.precertificacion.confirmarPrecertificacionLoading,
    confirmarPrecertificacionError:
      state.precertificacion.confirmarPrecertificacionError,

    autorizacionMadreData: state.precertificacion.getAutorizacionMadreData,
    autorizacionMadreLoading:
      state.precertificacion.getAutorizacionMadreDataLoading,
    autorizacionMadreError:
      state.precertificacion.getAutorizacionMadreDataError,

    getAutorizacionMadreData: state.precertificacion.getAutorizacionMadreData,
    getAutorizacionMadreDataLoading:
      state.precertificacion.getAutorizacionMadreDataLoading,
    getAutorizacionMadreDataError:
      state.precertificacion.getAutorizacionMadreDataError,
  };
};

const mapDispatchToProps = {
  clearSesion: AuthActions.clearSesion,
  getPrecertificacion: PrecertificacionActions.getPrecertificacion,
  confirmarPrecertificacion: PrecertificacionActions.confirmarPrecertificacion,
  getAutorizacionMadreData: PrecertificacionActions.getAutorizacionMadreData,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(ConfirmarPrecertificacionScreen);
